import React from 'react';
import './projects.css';

const projectsData = [
  {
    id: 1,
    title: 'Django REST API — Inventory System',
    description: 'A secure backend built with Django REST Framework featuring token authentication, role-based permissions, and a PostgreSQL data layer.',
    tags: ['Django', 'DRF', 'PostgreSQL', 'JWT'],
    icon: 'uil uil-server-network',
    github: '#',
    live: '#',
  },
  {
    id: 2,
    title: 'Sales Data Dashboard',
    description: 'An interactive analytics dashboard that cleans raw sales data with Pandas and visualizes trends and KPIs for stakeholders.',
    tags: ['Python', 'Pandas', 'Power BI', 'SQL'],
    icon: 'uil uil-chart-line',
    github: '#',
    live: '#',
  },
  {
    id: 3,
    title: 'E-commerce Storefront',
    description: 'A fullstack e-commerce app with a React frontend, Django backend, MongoDB product catalog, and EmailJS-powered order notifications.',
    tags: ['React', 'Django', 'MongoDB', 'REST API'],
    icon: 'uil uil-shopping-cart',
    github: '#',
    live: '#',
  },
];

const Projects = () => {
  return (
    <section className="projects section" id="portfolio">
      <h2 className="section__title">Projects</h2>
      <span className="section__subtitle">Some of My Work</span>

      <div className="projects__container container grid">
        {projectsData.map(({ id, title, description, tags, icon, github, live }) => (
          <div className="project__card" key={id}>
            <div className="project__placeholder">
              <i className={icon}></i>
            </div>
            <div className="project__content">
              <h3 className="project__title">{title}</h3>
              <p className="project__description">{description}</p>
              <div className="project__tags">
                {tags.map((tag) => (
                  <span className="project__tag" key={tag}>{tag}</span>
                ))}
              </div>
              <div className="project__links">
                <a href={github} target="_blank" rel="noreferrer" className="project__link">
                  <i className="uil uil-github-alt"></i> Code
                </a>
                <a href={live} target="_blank" rel="noreferrer" className="project__link">
                  <i className="uil uil-external-link-alt"></i> Live Demo
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Projects;